import { ApiServiceProps } from "DataTypes/Common";
import { get, post, put } from "Service";

const fetchCaseTypes = () => {
  const request = {
    subUrl: "OrderType/casetypes",
    data: {},
    isAuth: false,
  };
  return get(request);
};

const fetchOrderTypes = () => {
  const request = {
    subUrl: "OrderType",
    data: {},
    isAuth: false,
  };
  return get(request);
};

const createCase = (payload: any) => {
  const request = {
    subUrl: "Cases",
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const fetchCaseById = (payload: any) => {
  const request = {
    subUrl: `Cases/${payload.caseId}`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const getCaseListByUserId = (payload: any) => {
  const request: any = {
    subUrl: `Cases/client/${payload.clientId}`,
    data: {},
    isAuth: false,
    params: {
      pageNumber: payload.pageNumber || 1,
      pageSize: payload.pageSize || 10,
      searchQuery: payload.searchQuery || "",
      orderType: payload.orderTypeId ? parseInt(payload.orderTypeId) : 0,
      // Lets the backend apply the active/completed classification BEFORE pagination, so a page of
      // results is never truncated by cases outside the requested bucket. Omitted/empty for the
      // default (unfiltered-by-payment-status) view.
      ...(payload.paymentStatus ? { paymentStatus: payload.paymentStatus } : {}),
      // Opt-in only: hides ODR cases the current user hasn't consented to/accepted yet. Only the
      // chat list wants that (chat access should be consent-gated) — pages like Dispute Directory
      // need to show a pending assignment so the professional can actually see and act on it, so
      // they must NOT pass this.
      ...(payload.applyOdrConsentFilter ? { applyOdrConsentFilter: true } : {}),
    },
  };
  return get(request);
};

const getDashboardCount = () => {
  const request = {
    subUrl: `Cases/counts/by-ordertype/me`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const getAdminPendingFailedOrders = (payload: any) => {
  const request: any = {
    subUrl: `Cases/admin/pending-failed-orders`,
    data: {},
    isAuth: false,
    params: {
      pageNumber: payload.pageNumber || 1,
      pageSize: payload.pageSize || 10,
      searchQuery: payload.searchQuery || "",
      orderType: payload.orderTypeId ? parseInt(payload.orderTypeId) : 0,
    },
  };
  return get(request);
};

const getAdminCompletedOrders = (payload: any) => {
  const request: any = {
    subUrl: `Cases/admin/completed-orders`,
    data: {},
    isAuth: false,
    params: {
      pageNumber: payload.pageNumber || 1,
      pageSize: payload.pageSize || 10,
      searchQuery: payload.searchQuery || "",
      orderType: payload.orderTypeId ? parseInt(payload.orderTypeId) : 0,
    },
  };
  return get(request);
};

const DocumentBulkUpload = (payload: any) => {
  const request = {
    subUrl: `Attachments/cases-bulk-upload`,
    data: payload,
    dataType: "form-data",
    isAuth: false,
  };
  return post(request);
};

const BulkUpload = (payload: any) => {
  const request = {
    subUrl: `Cases/bulk-upload`,
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const createPaymentSession = (payload: any) => {
  const request = {
    subUrl: `Payments/create-session/${payload.caseId}`,
    isAuth: false,
  };
  return post(request);
}

const downloadInvoice = (payload: { caseId: number; paymentId?: number }) => {
  const request: any = {
    subUrl: `Cases/download-invoice/${payload.caseId}`,
    isAuth: false,
    excel: true, // Use blob response type
    params: {},
  };
  if (payload.paymentId) {
    request.params.paymentId = payload.paymentId;
  }
  return get(request);
};

const createCaseByEMitra = (payload: any) => {
  const request = {
    subUrl: "Cases/emitra-create",
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const validateBulkUpload = (payload: any) => {
  const request = {
    subUrl: `Attachments/cases-bulk-validate`,
    data: payload,
    dataType: "form-data",
    isAuth: false,
  };
  return post(request);
};

const confirmBulkUpload = (payload: any) => {
  const request = {
    subUrl: `Attachments/cases-bulk-confirm`,
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const getClientBatches = (payload: { clientId: number }) => {
  const request = {
    subUrl: `Cases/batches/client/${payload.clientId}`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const getBatchDetails = (payload: { batchId: number }) => {
  const request = {
    subUrl: `Cases/batch/${payload.batchId}`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const CaseApi = {
  fetchCaseTypes,
  fetchOrderTypes,
  createCase,
  fetchCaseById,
  getCaseListByUserId,
  getDashboardCount,
  BulkUpload,
  DocumentBulkUpload,
  createPaymentSession,
  downloadInvoice,
  createCaseByEMitra,
  validateBulkUpload,
  confirmBulkUpload,
  getClientBatches,
  getBatchDetails,
  getAdminPendingFailedOrders,
  getAdminCompletedOrders,
};

export default CaseApi;
